import { Routes } from '@angular/router';
import { MainComponent } from './pages/main/main.component';
import { LoginComponent } from './pages/login/login.component';
import { authGuard } from './guards/auth.guard';
import { noAuthGuard } from './guards/no-auth.guard';
import { AdminPanelComponent } from './pages/admin-panel/admin-panel.component';

export const routes: Routes = [
    { path: '', component: MainComponent, canActivate:[authGuard], data: { authenticated: true } },
    { path: 'login', component: LoginComponent, canActivate:[noAuthGuard] },
    { path: 'panel', component: AdminPanelComponent, canActivate:[authGuard], data: { authenticated: true } },
];
